// extracted by mini-css-extract-plugin
export default {"holder":"packages_holder__YQgRi","packagingWrap":"packages_packagingWrap__E2zfd"};